import md5 from 'md5';
import {
  addEventerType,
  ClientHostType,
  GoodsListType,
  LocalStorageKey,
  LoginStatus,
  PayInfo,
  PayInfoSource,
  PrivilegeType,
  SessionStorageKey,
  TicketListType,
} from '@/types';
import { isWeChat } from './getMobileDetect';
import { useStore } from '@/store';
import { localStorageHelper, sessionStorageHelper } from './localCache';
import dayjs from '@/utils/timezone/dayjs';
import { cloneDeep } from 'lodash';
import { COUPON_USE_TYPE } from '@/components/SeclectCoupon';

export function getQueryStringByName(name: string) {
  const { href } = window.location;
  const params = new URLSearchParams(new URL(href).search);
  const searchParams = {};
  for (let [key, value] of params) {
    searchParams[key] = value;
  }
  if (searchParams[name]) return searchParams[name];
  return '';
}

// 添加事件监听器的函数
export function addEventerHelper({ event, element, listener, others }: addEventerType): () => void {
  element.addEventListener(event, listener, others);
  return () => element.removeEventListener(event, listener);
}

function bin2hex(str) {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    result += int16_to_hex(str.charCodeAt(i));
  }
  return result;
}

function int16_to_hex(i) {
  let result = i.toString(16);
  let j = 0;
  while (j + result.length < 4) {
    result = `0${result}`;
    j++;
  }
  return result;
}

export function cans() {
  const localCacheCanvasId = localStorageHelper.get(LocalStorageKey.canvasId) || '';
  if (localCacheCanvasId) {
    return localCacheCanvasId;
  }
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
  let txt = window.location.host;
  ctx.textBaseline = 'top';
  ctx.font = "14px 'Arial'";
  ctx.textBaseline = 'iCirena' as CanvasTextBaseline;
  ctx.fillStyle = '#f60';
  ctx.fillRect(125, 1, 62, 20);
  ctx.fillStyle = '#069';
  ctx.fillText(txt, 2, 15);
  ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
  ctx.fillText(txt, 4, 17);

  let b64 = canvas.toDataURL().replace('data:image/png;base64,', '');
  let bin = atob(b64);
  let creatTime = new Date().getTime();
  let crc = bin2hex(bin);
  let md5Init = crc + creatTime;
  let crcMd5 = md5(md5Init).toUpperCase();
  if (crcMd5) {
    localStorageHelper.set(LocalStorageKey.canvasId, crcMd5);
  }
  return crcMd5;
}

/**
 * verification
 * @param str 检查内容
 * @param type 检测类型
 * @returns {boolean}
 */
export const verification = (str, type) => {
  if (str === '') {
    return false;
  } else if (type === 'PassWord') {
    if (
      !/^\d{6}$/.test(str) ||
      /^(\d)\1+$/.test(str) ||
      /^(?:0(?=1)|1(?=2)|2(?=3)|3(?=4)|4(?=5)|5(?=6)|6(?=7)|7(?=8)|8(?=9)){5}\d$/.test(str) ||
      /^(?:9(?=8)|8(?=7)|7(?=6)|6(?=5)|5(?=4)|4(?=3)|3(?=2)|2(?=1)|1(?=0)){5}\d$/.test(str)
    ) {
      // 不是6位数字 || 全一样 || 顺增 || 顺减
      return false;
    } else {
      return true;
    }
  } else if (type === 'CardPassWord') {
    if (
      !/^\d{4,12}$/.test(str) ||
      /^(\d)\1+$/.test(str) ||
      /^(?:0(?=1)|1(?=2)|2(?=3)|3(?=4)|4(?=5)|5(?=6)|6(?=7)|7(?=8)|8(?=9)){3,11}\d$/.test(str) ||
      /^(?:9(?=8)|8(?=7)|7(?=6)|6(?=5)|5(?=4)|4(?=3)|3(?=2)|2(?=1)|1(?=0)){3,11}\d$/.test(str)
    ) {
      // 不是6位数字 || 全一样 || 顺增 || 顺减
      return false;
    } else {
      return true;
    }
  } else if (type === 'notEasyPwd') {
    // 非简单密码
    if (/^\d+$/.test(str)) {
      // 都是数字
      // 顺序，逆序，同号
      let flag1 = true;
      let flag2 = true;
      let flag3 = true;
      const arr = str.split('');
      for (let i = 0; i < arr.length; i++) {
        if (i < arr.length - 1) {
          // 顺序 || 逆序 || 同号
          if (parseInt(arr[i], 10) + 1 !== parseInt(arr[i + 1], 10)) {
            flag1 = false;
          }
          if (parseInt(arr[i], 10) - 1 !== parseInt(arr[i + 1], 10)) {
            flag2 = false;
          }
          if (parseInt(arr[i], 10) !== parseInt(arr[i + 1], 10)) {
            flag3 = false;
          }
        }
      }
      return !(flag1 || flag2 || flag3); // 只有一个是顺序，逆序，同号，就返回false
    } else {
      // 相同就false
      let flag = false;
      const arr = str.split('');
      for (let i = 0; i < arr.length; i++) {
        if (i < arr.length - 1 && arr[i] !== arr[i + 1]) {
          flag = true;
        }
      }
      return flag;
    }
  } else {
    let reg = '' as string | RegExp;
    switch (type) {
      case 'mobile':
        reg = /^\+?[1-9]\d{7,11}$/;
        break;
      case 'Url':
        reg = /^http:\/\/[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/;
        break;
      case 'IdCard':
        reg = /^\d{15}(\d{2}[A-Za-z0-9])?$/;
        break;
      case 'QQ':
        reg = /^[1-9]\d{4,8}$/;
        break;
      case 'UserPassWord':
        reg = /^[A-Za-z0-9]{6,18}$/;
        break;
      case 'SixNumPassWord':
        reg = /^[0-9]{6}$/;
        break;
      case 'Money':
        // 12.34, 也包含 .11  3.
        reg = /^(\.{1})?(([1-9]\d*)|0)(\.\d{0,2})?$/;
        break;
      case 'email':
        reg = /^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        break;
      case 'emoji':
        reg =
          /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|[\u270a-\u270c]|\uD83E[\uDD10-\uDD5D]|[\u2600\u2601\u2614\u2615\u26a1\u26bd\u26be\u26c4\u26f3\u26fa\u2b50\u2728\u2764])/;
        break;
      default:
        reg = /^((\(\d{2,3}\))|(\d{3}\-))?(\(0\d{2,3}\)|0\d{2,3}-)?[1-9]\d{6,7}(\-\d{1,4})?$/;
        break;
    }

    if (type !== 'email') {
      return reg.test(str);
    } else {
      let flag = reg.test(str);
      if (flag) {
        flag = str.slice(str.indexOf('@') + 1).length <= 25;
      }
      return flag;
    }
  }
};

export const getPayReturnUrl = ({ url }) => {
  let curUrl = url;
  let otherUrl = '';
  // if (window.location.hostname === 'pre-site.icirena.ai') {
  //   otherUrl = '/app/icirena-fe/website-icirena';
  // }
  const returnUrl = `${window.location.origin}${otherUrl}${curUrl}${window.location.search}`;
  return returnUrl;
};

/**
 * @description OriginalPrice-[原价] PrivilegePrice-[优惠后的价格=实际支付价格]
 */
export const packPayInfo = (privilege: PrivilegeType): PayInfo => {
  /** 独立信息 */
  const ticket = {
    // 票原价
    ticketOriginalPrice: 0,
    // 票优惠后价
    ticketPrivilegePrice: 0,
    // 总票张数
    ticketTotalCount: 0,
    // 总服务费
    totalServePrice: 0,
    activityExtended: '',
  };
  const goods = {
    goodsOriginalPrice: 0,
    goodsPrivilegePrice: 0,
  };
  // map数据
  const ticketList: Record<number, TicketListType> = {};
  const goodsList: GoodsListType[] = [];
  const { ticketInfos, goodsInfos } = cloneDeep(privilege);
  ticketInfos?.forEach((item) => {
    const {
      ticketOriginalPrice,
      ticketPrivilegePrice,
      ticketTypeId,
      ticketTypeName,
      privilegeTagId,
      // ticketCost,
      // 服务费 2024 7 17 19:26 经过前段后端测试一致决定 该字段是服务费 remainAgentFee
      remainAgentFee,
    } = item;
    // 总：票原价
    ticket.ticketOriginalPrice += Number(ticketOriginalPrice);
    // 总：票优惠后价
    ticket.ticketPrivilegePrice += Number(ticketPrivilegePrice);
    // 总：票张数
    ticket.ticketTotalCount += Number(item.ticketCount);
    ticket.totalServePrice += Number(remainAgentFee);
    const isOriginalPrice = ticketOriginalPrice === ticketPrivilegePrice ? 'originalPrice' : 'privilegePrice';
    const key = isOriginalPrice + ticketTypeId + ticketPrivilegePrice;
    if (!ticketList[key]) {
      ticketList[key] = {
        ticketTypeName,
        ticketTypeId,
        ticketCount: 0,
        privilegeTagId,
        ticketPrivilegePrice,
        // 票价 - 如果存在服务费则减去服务费-[独立拿出来显示的数据]
        ticketOriginalPrice: remainAgentFee
          ? Number(ticketOriginalPrice) - Number(remainAgentFee)
          : ticketOriginalPrice,
        // 开始用错了
        ticketCost: remainAgentFee,
        // 用于核销会员码
        activityExtended: privilege.memberNumber,
      };
    }
    ticketList[key].ticketCount += 1;
  });
  goodsInfos?.map((item) => {
    const { goodsCount, goodsOriginalPrice, goodsPrivilegePrice } = item;
    // 卖品价格 累计
    // 1. 卖品总原价
    // 2. 卖品总优惠后价
    goods.goodsPrivilegePrice += Number(goodsCount) * Number(goodsPrivilegePrice);
    goods.goodsOriginalPrice += Number(goodsCount) * Number(goodsOriginalPrice);

    // 套餐的需要传入你选的子项
    const cacheGoodsList = useStore.getState().orderObj.pos.goodsParamsJson;

    const idList = cacheGoodsList.map((item) => item.goodsId);
    if (idList.includes(item.goodsId)) {
      item.category = cacheGoodsList.find((item) => item.goodsId === item.goodsId).category;
    }
    const findIndex = goodsList.findIndex((item) => item.goodsId === item.goodsId);
    if (findIndex > -1) {
      // 已存在
      let preGoodsCount = goodsList[findIndex].goodsCount;
      goodsList[findIndex].goodsCount = Number(goodsCount) + Number(preGoodsCount);
      goodsList[findIndex].quantity = String(goodsList[findIndex].goodsCount);
    } else {
      goodsList.push({
        ...item,
        quantity: String(goodsCount),
        goodsSinglePrivilegePrice: goodsPrivilegePrice, // 单个优惠价
        goodsSingleOriginalPrice: goodsOriginalPrice, // 单个原价
      });
    }
  });
  return {
    ...privilege,
    ...ticket,
    // ---------------------------- 重要信息 ----------------------------
    // 总原价
    originalTotalPrice: ticket.ticketOriginalPrice + goods.goodsOriginalPrice,
    // 总优惠后价[实际支付价格]
    totalPrice: ticket.ticketPrivilegePrice + goods.goodsPrivilegePrice,
    // ---------------------------- 次重要信息 ----------------------------
    // 总优惠 = 票优惠 + 卖品优惠
    priceDiff:
      ticket.ticketOriginalPrice - ticket.ticketPrivilegePrice + (goods.goodsOriginalPrice - goods.goodsPrivilegePrice),
    // 票优惠 = 票原价 - 票优惠后价
    ticketPriceDiff: ticket.ticketOriginalPrice - ticket.ticketPrivilegePrice,
    // 商品优惠 = 商品原价 - 商品优惠后价
    goodsPriceDiff: goods.goodsOriginalPrice - goods.goodsPrivilegePrice,
    // ---------------------------- 自定义信息 ----------------------------
    canUseCoupon: false,
    payStatus: PayInfoSource.CREATED,
    curPrivilege: privilege,
    // map数据展示
    ticketList: Object.values(ticketList),
    goodsList,
    // 用户核对会员码
    activityExtended: privilege.memberNumber,
  };
};

export const packCouponPayInfo = (
  discountPriceInfo,
  originPayinfo,
  { AIAcouponInfo = {} as any, couponList = [] as any[] },
  aiaMemberCode,
) => {
  // console.log('[dev]看看-discountPriceInfo, originPayinfo, couponInfo:', discountPriceInfo, originPayinfo, couponInfo);

  const {
    totalTicketPrivilegePrice,
    totalGoodsPrivilegePrice,
    /**
     * 优惠总价
     */
    privilegeTotalPrice,
    canUseCoupon,
    preferCoupons,
  } = discountPriceInfo;
  const res = { ...originPayinfo };
  // 外部展示价格 // 实际支付价格
  res.totalPrice = privilegeTotalPrice;
  res.privilegeTotalPrice = privilegeTotalPrice;
  //
  res.ticketPrivilegePrice = parseInt(totalTicketPrivilegePrice);
  res.goodsPrivilegePrice = parseInt(totalGoodsPrivilegePrice);
  res.couponsDiscount = parseInt(res.originalTotalPrice) - parseInt(res.totalPrice);
  res.payMethod = '';
  res.priceDiff = parseInt(res.originalTotalPrice) - parseInt(privilegeTotalPrice);
  res.canUseCoupon = canUseCoupon;
  res.payStatus = PayInfoSource.CREATED;
  // 劵码 - 49 阳改 - aia
  let _payments: any[] = [];
  if (AIAcouponInfo) {
    AIAcouponInfo.dataList?.forEach((item) => {
      let coupons = preferCoupons?.find((t) => t.couponCode === item.couponCode);
      let couponCodeParams;
      if (item.productType === 3) {
        couponCodeParams = `${item.couponCode}-${coupons?.couponType}`;
        couponCodeParams += '-TICKET';
      } else {
        couponCodeParams = `${item.couponCode}-${coupons?.couponType}`;
      }
      _payments.push({
        payMethod: 'COUPON',
        couponCodeParams,
        paymentAliasCode: 'AIA',
        // 新增 aia会员
        aiaMemberCode: aiaMemberCode?.[item.couponCode],
      });
    });
  }
  if (couponList) {
    couponList?.forEach((item) => {
      let coupons = preferCoupons?.find((t) => t.couponCode === item.couponCode);
      let couponCodeParams;
      const istongyong =
        item.useType === COUPON_USE_TYPE.COMMON ||
        item.concreteProductType === COUPON_USE_TYPE.COMMON ||
        item.productType === 3;
      if (istongyong) {
        couponCodeParams = `${item.couponCode}-${coupons?.couponType}`;
        couponCodeParams += `-${item.useSetType}`;
      } else {
        couponCodeParams = `${item.couponCode}-${coupons?.couponType}`;
      }
      _payments.push({
        payMethod: 'COUPON',
        couponCodeParams,
      });
    });
  }

  res.couponPayments = _payments;
  delete res.activityInfos;
  delete res.curPrivilege;
  // // 票优惠
  res.ticketPriceDiff = res.priceDiff;
  return res;
};

export function formatCentsToYuan(cents) {
  if (!/^\d+$/.test(cents)) {
    return null;
  }
  // 0则直接返回
  if (cents === 0) {
    return 0;
  }
  // 将分转换为元，并保留两位小数
  return (cents / 100).toFixed(2);
}

export const getChannelSettingDomain = () => {
  let domain = 'https://h5ecticket.icirena.ai/';
  let preHostList = ['pre-site.icirena.ai'];
  // console.log('[dev]看看-process.env.NODE_ENV:', process.env.NODE_ENV);
  if (preHostList.includes(window.location.hostname) || process.env.NODE_ENV === 'development') {
    domain = 'https://pre-h5ecticket-oversea.icirena.ai/';
  }
  return domain;
};
/**
 * 获取openId
 * @param wapid
 * @param url
 */
export function getPayOpenId(quireOpenId?: string) {
  const { orderObj } = useStore.getState();
  // 银河不需要获取 // 先写死
  if (!quireOpenId) {
    return '';
  }
  if (!isWeChat()) {
    // console.log('[dev]看看-getPayOpenIdisWeChat不是微信环境');
    // 不在微信直接失效
    return '';
  }
  // 微信无公众号修改兼容操作
  if (orderObj?.channelSetting.channelSetting?.weixin?.type === '') {
    return '';
  }

  const { openid, time } = sessionStorageHelper.get(SessionStorageKey.wxPayOpenId) || {};
  if (openid && Boolean(time) && dayjs(time).isAfter(dayjs(new Date()))) {
    // console.log('[dev]看看-本地有未过期的openId', openid);
    return openid;
  }

  const queryOpenid = getQueryStringByName('openid'); // openID
  const type = getQueryStringByName('reqSource'); // openid得类型
  // type是类型 auth 是数字例如897fxxxx 假的
  //         getOpenId，是ooww.....才是真正的
  // 情况1: 有openid并且类型是geOpenid才能用
  if (queryOpenid && type === 'getOpenId') {
    // console.log('情况1: 有openid并且类型是geOpenid才能用', queryOpenid);
    sessionStorageHelper.set(SessionStorageKey.wxPayOpenId, {
      openid: queryOpenid,
      time: new Date().getTime() + 1000 * 60 * 3,
    });

    return queryOpenid;
  }

  // 情况2: 没有openID或者openid的类型不对去获取真的
  if (!queryOpenid || type === 'auth') {
    let url = `${getChannelSettingDomain()}lark/wechat/getOpenid?wapid=${getQueryStringByName(
      'wapid',
    )}&scope=snsapi_base&returnUrl=${encodeURIComponent(window.location.href)}`;
    window.localStorage.setItem('songan', JSON.stringify(url));
    window.localStorage.setItem('songanTip', JSON.stringify('没有openID或者openid的类型不对去获取真的'));
    // const domLoading = document.querySelector('.ui-icon-loading');
    // if (domLoading) {
    //   domLoading.classList.remove('fn-hide');
    // }
    window.location.href = '';
  }
  return '';
}

export function getLoginOpenid() {
  const { orderObj } = useStore.getState();
  if (!isWeChat()) {
    // console.log('[dev]看看-getPayOpenIdisWeChat不是微信环境');
    // 不在微信直接失效
    return '';
  }
  // 微信无公众号修改兼容操作
  if (orderObj?.channelSetting.channelSetting?.weixin?.type === '') {
    // console.log('[dev]看看-微信无公众号修改兼容操作');
    return '';
  }
  const { openid, time } = sessionStorageHelper.get(SessionStorageKey.wxLoginOpenId) || {};
  if (openid && Boolean(time) && dayjs(time).isAfter(dayjs(new Date()))) {
    // console.log('[dev]看看-本地有未过期的openId', openid);
    return openid;
  }

  const queryOpenid = getQueryStringByName('openid'); // openID
  const type = getQueryStringByName('reqSource'); // openid得类型
  // type是类型 auth 是数字例如897fxxxx 假的
  //         getOpenId，是ooww.....才是真正的
  // 情况1: 有openid并且类型是geOpenid才能用
  if (queryOpenid && type === 'auth') {
    // console.log('情况1: 有openid并且类型是geOpenid才能用', queryOpenid);
    sessionStorageHelper.set(SessionStorageKey.wxLoginOpenId, {
      openid: queryOpenid,
      time: new Date().getTime() + 1000 * 60 * 3,
    });

    return queryOpenid;
  }

  // 情况2: 没有openID或者openid的类型不对去获取真的
  if (!queryOpenid || type === 'getOpenId') {
    let url = `${getChannelSettingDomain()}lark/wechat/auth?wapid=${getQueryStringByName('wapid')}&scope=snsapi_userinfo&returnUrl=${encodeURIComponent(window.location.href)}`;
    window.location.href = url;
  }
}

/// 是否是游客登录
export function isGuesLogin() {
  const { baseObj } = useStore();
  return baseObj.user?.account?.registerType === 'guest';
}

/**
 * 获取全部小写的 ua
 * @returns {string}
 */
const getUa = () => {
  let ua = (navigator && navigator.userAgent) || '';
  return ua.toLowerCase();
};

/**
 * 判断是否在微信浏览器环境
 * @returns {boolean}
 */
export const isWechat = () => {
  let ua = getUa();
  return ua.includes('micromessenger') && !ua.includes('miniprogram');
};
/**
 * chineseNewDate 中国时区时间转换
 * @param date
 * @returns {Date}
 */

export function chineseNewDate(date) {
  if (date) {
    if (typeof date === 'string') {
      // 2017-02-04 :00:00:00 //中国标准时间
      // ==> 改成移动端兼容的 2017/02/04 00:00:00
      date = date.replace(new RegExp(/-/gm), '/');
      return new Date(date);
    } else if (typeof date === 'number') {
      return new Date(parseInt(String(date)) + (new Date().getTimezoneOffset() - -480) * 60 * 1000);
    }
  } else {
    return new Date(new Date().getTime() + (new Date().getTimezoneOffset() - -480) * 60 * 1000);
  }
  return '';
}
/**
 * 日期显示转换方法 2016-01-01 01:01（notime：true时返回结果不带时间部分；PS：2016-01-01）
 * @param date 时间戳
 * @param notime 是否需要时间
 * @param noDate
 * @returns {string}
 */
export function getDateFormatText(date, notime, noDate) {
  const d: any = chineseNewDate(parseInt(date));
  if (noDate) {
    return notime
      ? ''
      : `${(d.getHours() < 10 ? '0' : '') + d.getHours()}:${d.getMinutes() < 10 ? '0' : ''}${d.getMinutes()}`;
  } else {
    return `${d.getFullYear()}-${d.getMonth() < 9 ? '0' : ''}${d.getMonth() + 1}-${
      d.getDate() < 10 ? '0' : ''
    }${d.getDate()}${
      notime ? '' : ` ${d.getHours() < 10 ? '0' : ''}${d.getHours()}:${d.getMinutes() < 10 ? '0' : ''}${d.getMinutes()}`
    }`;
  }
}

export const transformPriceFixed = (v, mult = 100, decimal = 2) => {
  if (!v) return;

  return (~~v / mult).toFixed(decimal);
};

/**
 * 日期格式转换
 * @param date 时间戳
 * @param format 转换格式  clone为默认修改所有未传的
 * @returns {string}
 * */
export const formatterDate = (data) => {
  const { date = '' } = data;
  let format = {
    default: 'YYYY年MM月DD日 HH:mm',
    en: 'YYYY.MM.DD HH:mm',
    zh_cn: 'YYYY年MM月DD日 HH:mm',
    zh_tw: 'YYYY年MM月DD日 HH:mm',
    ...data.format,
  };
  let clone = '';
  const { baseObj } = useStore.getState();

  if (!date) {
    return date;
  }

  if (baseObj.currentLanguage === 'en-US') {
    clone = !data?.format?.en ? data?.format?.clone || format.en : data?.format?.en;
    return dayjs(Number(date)).tz().format(clone);
  } else if (baseObj.currentLanguage === 'zh-CN') {
    clone = !data?.format?.zh_cn ? data?.format?.clone || format.zh_cn : data?.format?.zh_cn;
    return dayjs(Number(date)).tz().format(clone);
  } else if (baseObj.currentLanguage === 'zh-TW') {
    clone = !data?.format?.zh_tw ? data?.format?.clone || format.zh_tw : data?.format?.zh_tw;
    return dayjs(Number(date)).tz().format(clone);
  } else {
    return dayjs(Number(date)).tz().format(format.default);
  }
};
// 英文空格处理   如果带参数英文环境参数返回null
export const EnglishSpace = (data?: any) => {
  const { baseObj } = useStore.getState();

  if (data) {
    return baseObj.currentLanguage === 'en-US' ? '' : data;
  }

  return baseObj.currentLanguage === 'en-US' ? ' ' : '';
};

// 是否卖品活动优惠
export const isGoodsPrivilege = (goods) => {
  if (!goods.privilegeTags?.[0]) return false;
  const { budget, remainPromoAmount, shortActivityTag } = goods.privilegeTags[0];
  if (!budget && !remainPromoAmount) return false;
  return shortActivityTag === '惠';
};
const handleCategoryParams = (goods, select) => {
  const cartGoods = {
    ...goods,
  };
  cartGoods.category = select.category;
  cartGoods.itemsNumber = select.itemsNumber;
  cartGoods.label = select.label;
  cartGoods.labelArr = select.labelArr;
  cartGoods.goodsIdArr = select.goodsIdArr;
  cartGoods.goodsNameArr = select.goodsNameArr;
  cartGoods.itemTypeArr = select.itemTypeArr;
  cartGoods.totalSelectedNumber = cartGoods.number;
  return cartGoods;
};

// 套餐优惠计算
export const calcCategoryPrivilege = (goods, totalPrice, select) => {
  if (!goods.privilegeTags) return;
  const cartList = [] as any[];
  const { budget, budgetCategory, remainPromoAmount, minPrice } = goods.privilegeTags[0];
  const privilegePrice = goods.standardPrice - minPrice;
  let privilegeNumber = goods.number;
  if (budget && budget < goods.number) {
    privilegeNumber = budget;
  }
  if (remainPromoAmount && privilegePrice * privilegeNumber > remainPromoAmount) {
    // 超过优惠金额全部按原价计算
    const cartGoods = {
      ...goods,
    };
    cartGoods.price = goods.standardPrice;
    cartGoods.quantity = cartGoods.number;
    cartGoods.privilegeTags = null;
    const otherParams = handleCategoryParams(cartGoods, select);
    const result = {
      ...cartGoods,
      ...otherParams,
    };
    cartList.push(result);
    totalPrice += goods.number * goods.standardPrice;
  } else {
    if (!budget) {
      const cartGoods = {
        ...goods,
      };
      cartGoods.quantity = cartGoods.number;
      cartGoods.price = cartGoods.displayPrice;
      const otherParams = handleCategoryParams(cartGoods, select);
      const result = {
        ...cartGoods,
        ...otherParams,
      };
      cartList.push(result);
      totalPrice += goods.number * goods.displayPrice;
    } else {
      // 未超过优惠金额根据budget判断
      // 小于预算数，全部可使用优惠
      if (goods.number <= budget) {
        const cartGoods = {
          ...goods,
        };
        cartGoods.quantity = cartGoods.number;
        cartGoods.price = cartGoods.displayPrice;
        const otherParams = handleCategoryParams(cartGoods, select);
        const result = {
          ...cartGoods,
          ...otherParams,
        };
        cartList.push(result);
        totalPrice += goods.number * goods.displayPrice;
      } else {
        // 单用户总预算：超过预算数，部分使用优惠
        if (budgetCategory === 'USER') {
          const disabledAmount = goods.number - budget;
          const otherParams = handleCategoryParams(goods, select);
          const disabledGoods = {
            ...goods,
            price: goods.standardPrice,
            quantity: disabledAmount,
            ...otherParams,
          };
          disabledGoods.privilegeTags = null;
          const privilegeGoods = {
            ...goods,
            price: goods.displayPrice,
            quantity: budget,
            ...otherParams,
          };
          cartList.push(privilegeGoods, disabledGoods);
          totalPrice += budget * goods.displayPrice + disabledAmount * goods.standardPrice;
        } else {
          // 活动总预算：只要超过，都是原价
          const cartGoods = {
            ...goods,
          };
          cartGoods.price = goods.standardPrice;
          cartGoods.quantity = cartGoods.number;
          cartGoods.privilegeTags = null;
          const otherParams = handleCategoryParams(cartGoods, select);
          const result = {
            ...cartGoods,
            ...otherParams,
          };
          cartList.push(result);
          totalPrice += goods.number * goods.standardPrice;
        }
      }
    }
  }
  return [cartList, totalPrice];
};
// 单品优惠计算
export const calcPrivilege = (goods, totalPrice) => {
  if (!goods.privilegeTags) return;
  const { budget, budgetCategory, remainPromoAmount, minPrice } = goods.privilegeTags[0];
  const privilegePrice = goods.standardPrice - minPrice;
  const cartList = [] as any[];
  let privilegeNumber = goods.number;
  if (budget && budget < goods.number) {
    privilegeNumber = budget;
  }
  if (remainPromoAmount && privilegePrice * privilegeNumber > remainPromoAmount) {
    // 超过优惠金额全部按原价计算
    const cartGoods = {
      ...goods,
    };
    cartGoods.price = goods.standardPrice;
    cartGoods.quantity = cartGoods.number;
    cartGoods.privilegeTags = null;
    cartList.push(cartGoods);
    totalPrice += goods.number * goods.standardPrice;
  } else {
    if (!budget) {
      const cartGoods = {
        ...goods,
      };
      cartGoods.quantity = cartGoods.number;
      cartGoods.price = cartGoods.displayPrice;
      cartList.push(cartGoods);
      totalPrice += goods.number * goods.displayPrice;
    } else {
      // 未超过优惠金额根据budget判断
      // 小于预算数，全部可使用优惠
      if (goods.number <= budget) {
        const cartGoods = {
          ...goods,
        };
        cartGoods.quantity = cartGoods.number;
        cartGoods.price = cartGoods.displayPrice;
        cartList.push(cartGoods);
        totalPrice += goods.number * goods.displayPrice;
      } else {
        // 单用户总预算：超过预算数，部分使用优惠
        if (budgetCategory === 'USER') {
          const disabledAmount = goods.number - budget;
          const disabledGoods = {
            ...goods,
            price: goods.standardPrice,
            quantity: disabledAmount,
            privilegeTags: null,
          };
          const privilegeGoods = {
            ...goods,
            price: goods.displayPrice,
            quantity: budget,
          };
          cartList.push(privilegeGoods, disabledGoods);
          totalPrice += budget * goods.displayPrice + disabledAmount * goods.standardPrice;
        } else {
          // 活动总预算：只要超过，都是原价
          const cartGoods = {
            ...goods,
          };
          cartGoods.price = goods.standardPrice;
          cartGoods.quantity = cartGoods.number;
          cartGoods.privilegeTags = null;
          cartList.push(cartGoods);
          totalPrice += goods.number * goods.standardPrice;
        }
      }
    }
  }
  return [cartList, totalPrice];
};

export const getLoginStatus = () => {
  const { baseObj } = useStore.getState();
  if (baseObj.user?.account?.registerType === 'guest') {
    return LoginStatus.GUEST;
  }
  if (baseObj.user?.account?.accountId) {
    return LoginStatus.LOGIN;
  }

  return LoginStatus.NOLOGIN;
};

export function DocTitle() {
  const { channel } = useStore();

  // 确定使用的语言
  const queryLang = getQueryStringByName('lang') || '';
  const localLang = localStorageHelper.get(LocalStorageKey.lang) || 'zh-TW';
  const lang = queryLang || localLang; // 如果链接上有语言参数则使用，否则使用本地存储的语言

  // 设定不同语言和频道的标题
  const titles = {
    [ClientHostType.acx]: {
      'zh-TW': 'ACX院線',
      'en-US': 'ACX Cinema',
      'zh-CN': 'ACX院线',
    },
    [ClientHostType.icirena]: {
      'zh-TW': '博納國際影城',
      'en-US': 'BONA FILM',
      'zh-CN': '博纳国际影城',
    },
    [ClientHostType.galaxy]: {
      'zh-TW': '「銀河影院」 | 澳門銀河，世界級的亞洲度假勝地',
      'en-US': 'Galaxy Cinemas - Watch Movies in Macao | Galaxy Macau, the World-Class Asian Resort Destination',
      'zh-CN': '「银河影院」 | 澳门银河，世界级的亚洲度假胜地',
    },
  };

  // 标准化语言代码
  const normalizedLang =
    {
      'zh-TW': 'zh-TW',
      zh_TW: 'zh-TW',
      en: 'en-US',
      en_US: 'en-US',
      'en-US': 'en-US',
      zh: 'zh-CN',
      zh_CN: 'zh-CN',
      'zh-CN': 'zh-CN',
    }[lang] || 'zh-TW'; // 默认使用繁体中文

  // 根据当前的频道和语言选择合适的标题
  const channelTitles = titles[channel] || titles[ClientHostType.galaxy];
  return channelTitles[normalizedLang];
}
